"use client";

import React from "react";
import NaccmLogo from "@/assets/images/about-us/awards-logo/naccm.png";
import AlcaLogo from "@/assets/images/about-us/awards-logo/alca.png";
import HCPLogo from "@/assets/images/about-us/awards-logo/trusted.png";
import CalaLogo from "@/assets/images/about-us/awards-logo/cala.png";
import BBBLogo from "@/assets/images/about-us/awards-logo/bbb.png";
import HomecareLogo from "@/assets/images/about-us/awards-logo/homecare.png";
import ProviderLogo from "@/assets/images/about-us/awards-logo/provider.png";
import AgingLogo from "@/assets/images/about-us/awards-logo/aging.png";
import CahsahLogo from "@/assets/images/about-us/awards-logo/cahsah.png";
import TopLogo from "@/assets/images/about-us/awards-logo/top.png";
import GreatLogo from "@/assets/images/about-us/awards-logo/great.png";
import EmployerLogo from "@/assets/images/about-us/awards-logo/employer.png";
import Employer2Logo from "@/assets/images/about-us/awards-logo/employer-2.png";
import BestLogo from "@/assets/images/about-us/awards-logo/best.png";
import WbencLogo from "@/assets/images/about-us/awards-logo/webenc.png";
import AwardsCarousel, { Slide } from "@/components/ui/carousel-awards";

export const SLIDES_DATA: Slide[] = [
  { name: "NACCM", logo: NaccmLogo },
  { name: "ALCA", logo: AlcaLogo },
  { name: "HCP", logo: HCPLogo },
  { name: "CALA", logo: CalaLogo },
  { name: "BBB", logo: BBBLogo },
  { name: "HC&C", logo: HomecareLogo },
  { name: "BOHC Provider", logo: ProviderLogo },
  { name: "ASA", logo: AgingLogo },
  { name: "CAHSAH", logo: CahsahLogo },
  { name: "San Francisco Chronicle", logo: TopLogo },
  { name: "GPTW", logo: GreatLogo },
  { name: "BOHC", logo: EmployerLogo },
  { name: "BOHC", logo: Employer2Logo },
  { name: "Fortune", logo: BestLogo },
  { name: "WBENC", logo: WbencLogo },
];

export interface AwardsProps {
  id?: string;
  slides?: Slide[];
}

const Awards: React.FC<AwardsProps> = ({
  id = "awards",
  slides = SLIDES_DATA,
}) => {
  return (
    <section
      id={id}
      className="w-full bg-primary-100"
    >
      <div className="w-full px-4 py-6 md:px-6 md:py-8 lg:mx-auto lg:max-w-lg lg:px-3 lg:py-10">
        <div className="pointer-events-none">
          <AwardsCarousel slides={slides} />
        </div>
      </div>
    </section>
  );
};

export default Awards;
